"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Filter;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Filter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "filter"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "72.396",
    cy: "26.605",
    r: "9.22"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "72.396",
    cy: "73.395",
    r: "9.22"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,29.105H10a2.5,2.5,0,0,1,0-5H90a2.5,2.5,0,0,1,0,5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,75.9H10a2.5,2.5,0,0,1,0-5H90a2.5,2.5,0,0,1,0,5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,52.5H10a2.5,2.5,0,0,1,0-5H90a2.5,2.5,0,0,1,0,5Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "27.604",
    cy: 50,
    r: "9.22"
  })))));
}